import Home from "../../pages/home";
import MarketPlace from "../../pages/marketPlace";
import Offers from "../../pages/offers";
import Publish from "../../pages/publish";

let allPublicRoute = [
  {
    path: "/",
    component: MarketPlace,
    name: "MarketPlace",
  },
];
let bookReaderRoute = [
  {
    path: "/",
    component: MarketPlace,
    name: "Market Place",
  },
  {
    path: "/home/:id",
    component: Home,
    name: "Home",
  },
  {
    path: "/offers",
    component: Offers,
    name: "Swap Offers",
  },
];
let publisherRoute = [
  {
    path: "/home/:id",
    component: Home,
    name: "Home",
  },
  {
    path: "/publish",
    component: Publish,
    name: "Publish Books",
  },
];
export { allPublicRoute, publisherRoute, bookReaderRoute };
